import React, { useState, useEffect, useRef, lazy, Suspense } from "react"
import axios from "axios"
const PublicMap = lazy(() => import("/components/PublicMap"))
const MobileForm = lazy(() => import("/components/MobileForm"))
import styled, { ThemeProvider } from "styled-components"
import cloneDeep from "lodash-es/cloneDeep"
import PublicList from "/components/PublicList"
import map from "lodash-es/map"
import min from "lodash-es/min"
import max from "lodash-es/max"
import has from "lodash-es/has"
import get from "lodash-es/get"
import set from "lodash-es/set"
import sortBy from "lodash-es/sortBy"
import forEach from "lodash-es/forEach"
import clone from "lodash-es/clone"
import uniq from "lodash-es/uniq"
import isEmpty from "lodash-es/isEmpty"
import filter from "lodash-es/filter"
import includes from "lodash-es/includes"
import remove from "lodash-es/remove"
import pull from "lodash-es/pull"
import find from "lodash-es/find"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle"
import { faHeart as faHeartFilled } from "@fortawesome/free-solid-svg-icons/faHeart"
import { faHeart } from "@fortawesome/free-regular-svg-icons/faHeart"
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle"
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt"
import { Range } from "rc-slider"
import { useStoreState, useStoreActions } from "easy-peasy"
import "rc-slider/assets/index.css"
import numeral from "numeral"
import { hb } from "/lib/hb.js"
import { wb } from "/lib/wb.js"
import LazyLoad from "react-lazy-load"
import { fireEvent } from "/lib/helpers"
import classNames from "classnames"

const Global = styled.div`
	position: relative;
	background-color: white;
	height: 100%;
`
const Map = styled.div`
	height: 100%;
	outline: 0;
`
const List = styled.div`
	${wb.lg`
		height: 100%;
		overflow-y: scroll;
	`}
`
const ToolsContainer = styled.div`
	padding: 0 20px;

	position: relative;
	z-index: 300;
	border-top: 1px solid #ccc;
	display: ${(props) =>
		props.mobileFiltersOpen === false || props.viewing == "amenities" || props.viewing == "area_features"
			? "none"
			: "block"};
	${hb.sm`
		min-height: 10vh;
	`}
	${hb.md`
		min-height: 6vh;
	`}
	${hb.lg`
		min-height: 8vh;
	`}
	${wb.lg`
		display: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? "none" : "flex")};
		justify-content: space-between;
		
	`}
	@media (max-width: 991px) {
		height: 100%;
		background-color: white;
		width: 100%;
		position: fixed;
		box-sizing: border-box !important;
		top: 0;
		left: 0;
		z-index: 3000;
	}
	${(props) => {
		if (props?.mode === "tv") {
			return `
				min-height:auto !important;
				height: 105px !important;
			`
		}
		return null
	}}
`
const FeaturesTools = styled.div`
	display: ${(props) => {
		if (props.mode === "area_features") return "block"
		return "none"
	}};
	${wb.lg`
		display: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? "flex" : "none")};
		min-height: 75px;
	`}
`
const FeaturesTitle = styled.div`
	color: white;
	position: relative;
	font-size: 16px;
	background-color: ${(props) => {
		if (get(props, `theme.tertiaryEnabled`)) return props.theme.accent_color
		return props.theme.color
	}};
	display: block;
	align-items: flex-start;
	padding-top: 15px;
	justify-content: center;
	flex: 1;
	border-right: 2px solid #ccc;
	${wb.lg`
		display: flex;
	`}
	> span {
		padding-left: 10px;
		${wb.lg`
			padding-left:0;
		`}
	}
`
const FeaturesSelectAllContainer = styled.div`
	display: block;
	width: 100%;
	padding: 15px 0;
	${wb.lg`
		position: absolute;
		display: flex;
		bottom: 0;
		left: 0;
		padding:0;
	`}
`
const FeaturesSelectAllBox = styled.div`
	flex: 1;
	text-align: left;
	border-top: 1px solid white;
	padding: 5px 0;
	color: white;
	font-size: 11px;
	padding-left: 10px;
	cursor: pointer;
	transition: 0.3s background-color ease-out;
	background-color: rgba(0, 0, 0, 0.1);
	line-height: 1em;
	&:hover {
		background-color: rgba(0, 0, 0, 0.2);
	}
	&:nth-child(1) {
		border-right: 1px solid white;
	}
	${wb.lg`
		text-align: center;
		padding-left:0;
	`}
`
const FeaturesList = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box !important;
	${wb.lg`
		flex:8;
	`}
`
const FeaturesItem = styled.li`
	padding: 8px 15px;
	border-bottom: 1px solid #ccc;
	border-right: 1px solid #ccc;
	box-sizing: border-box !important;
	cursor: pointer;
	transition: opacity 0.3s ease-out;
	opacity: 1;
	flex-basis: 50%;
	&:hover {
		opacity: 0.9;
	}
	${wb.lg`
		flex-basis:20%;
	`}
	color: #FFF;
	background-color: ${(props) => props.theme.color};
	svg {
		height: 20px;
		margin-right: 5px;
	}
	span {
		display: flex;
		align-items: center;
		opacity: ${(props) => {
			if (props.selects && props.selects.includes(props.category)) return 1
			return 0.4
		}};
	}
`
const Option = styled.div`
	color: ${(props) => {
		if (get(props, `theme.tertiaryEnabled`)) return props.theme.accent_color
		return props.theme.color
	}};
	opacity: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? 0 : 1)};
	transition: 0.3s opacity ease-out;
	position: relative;

	//width: 100%;
	flex: 1;
	padding: 3vh 5vw;
	font-size: 13px;
	box-sizing: border-box;
	border-bottom: 1px solid #ddd;
	.rc-slider-handle-dragging {
		box-shadow: none !important;
	}
	&:last-child {
		border-right: 0;
	}
	@media (min-width: 992px) {
		font-size: 14px;
		padding: 7px 30px 20px;
		border-bottom: 0;
	}
	@media (min-width: 1200px) {
		font-size: 16px;
		padding: 15px 50px 30px;
	}
	${wb.lg`
		box-sizing:content-box;
		border-right: 1px solid #ccc;
	`}
`
const MobileCloseContainer = styled.div`
	position: absolute;
	right: 0;
	font-size: 24px;
	top: 0;
	z-index: 300;
	padding: 20px 20px 30px 30px;
	${wb.lg`
		display:none;
	`}
`
const MobileFilterTrigger = styled.div`
	background-color: ${(props) => props.theme.color};
	color: white;
	font-size: 14px;
	position: sticky;
	padding: 1vh 0;
	top: 0;
	left: 0;
	width: 100%;
	text-align: center;
	z-index: 200;
	display: ${(props) => (props.mobileFiltersOpen === false && props.mode !== "area_features" ? "flex" : "none")};
	align-items: center;
	justify-content: space-between;
	${wb.lg`
		display:none;
	`}
`
const ToggleFavorites = styled.div`
	flex: 1;
	display: flex;
	font-size: 23px;
	justify-content: flex-start;
	box-sizing: content-box;
	> * {
		margin-left: 15px;
	}
`
const SearchFiltersButton = styled.span`
	flex: 2;
`
const OptionBox = styled.div`
	width: 100%;
	height: 100%;
	padding: 15px;
	box-sizing: border-box !important;
	position: fixed;
	top: 0px;
	left: 0;
	z-index: 400;
	background-color: white;
	font-size: 14px;
	max-width: 550px;
	color: #111;
	${wb.lg`
		width: 200%;
		padding: 15px 10%;
		top: 99%;
		left: 0;
		position: absolute;
		height:auto;
		box-shadow: 6px 7px 12px 0px #0000004a;
        border-radius: 10px;
		border:1px solid #ddd;
	`}
	${wb.xl`
		width: 180%;
	`}
	${wb.xxl`
		width: 130%;
		padding: 15px 5%;
	`}
`
const OptionScreen = styled.a`
	display: block;
	position: absolute;
	cursor: pointer;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	font-family: "Nunito Sans", sans-serif;
	font-weight: 600;
	&:hover {
		& ~ p {
			color: ${(props) => props.theme.gray};
		}
	}
`
const OptionList = styled.ul`
	list-style: none;
	padding: 20px 0 0;
	margin: 0;
	li {
		margin: 8px 0;
		cursor: pointer;
	}
	${wb.lg`
		padding: 0 20px 0 0;
	`}
`
const OptionClose = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;
	font-size: 24px;
	cursor: pointer;
	padding: 20px 20px 30px 30px;
`
const Label = styled.label`
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	font-size: 12px;
	@media (min-width: 1600px) {
		font-size: 14px;
		font-weight: normal;
	}
`
const SelectBuilders = styled.p`
	margin: 8px 0 0;
	color: ${(props) => props.theme.lightGray};
	font-size: 15px;
	transition: color 0.5s;
`
const SelectNeighborhoods = styled.p`
	margin: 8px 0 0;
	color: ${(props) => props.theme.lightGray};
	font-size: 15px;
	transition: color 0.5s;
`
const Reset = styled.div`
	display: flex;
	align-items: center;
	padding: 0 0 0 20px;
	justify-content: center;
	cursor: pointer;
	opacity: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? 0 : 1)};
	transition: 0.2s opacity ease-out;
	margin-top: 15px;
	@media (min-width: 992px) {
		margin-top: 0;
	}
`
const MobileSubmit = styled.div`
	background-color: ${(props) => props.theme.color};
	padding: 15px 30px;
	color: white;
	text-align: center;
	margin-top: 50px;
	${wb.lg`
		display:none;
	`}
`
const FavoriteBox = styled.div`
	display: none;
	opacity: ${(props) => (props.viewing == "amenities" || props.viewing == "area_features" ? 0 : 1)};
	transition: 0.2s opacity ease-out;
	${wb.lg`
		color: ${(props) => {
			if (get(props, `theme.tertiaryEnabled`)) return props.theme.accent_color
			return props.theme.color
		}};
		display: flex;
		align-items: center;
		padding: 15px 20px;
		justify-content: center;
		cursor: pointer;
		border-right:1px solid #ccc;
		flex-direction:column;
		justify-content:flex-start;
		font-size:18px;
	`}
	label {
		font-size: 13px;
	}
`
const BuilderCount = styled.span`
	background-color: #ebebeb;
	padding: 2px 5px;
	color: #222;
	margin-left: 15px;
	font-size: 12px;
`
const BuilderName = styled.span`
	font-size: 14px;
`
const ViewingFaves = styled.div`
	font-size: 12px;
	color: white;
	padding: 3px 15px;
	background-color: ${(props) => props.theme.color};
`
const FavoriteCount = styled.span`
	font-size: 11px;
	padding-left: 3px;
	font-weight: bold;
	color: #666;
`
const MapIcon = styled.a`
	color: white;
	font-size: 23px;
	display: flex;
	align-items: center;
	position: relative;
	flex: 1;
	display: flex;
	justify-content: flex-end;
	box-sizing: content-box;
	> * {
		margin-right: 15px;
	}
`
const NoMap = styled.div`
	flex: 1;
`

const SubmitBuilders = styled.li`
	background-color: ${(props) => {
		if (get(props, `theme.tertiaryEnabled`)) return props.theme.accent_color
		return props.theme.color
	}};
	color: white;
	text-align: center;
	padding: 5px 10px;
	margin-top: 25px !important;
`

function PipsyWrapper(props) {
	let url = window.location.href
	let propertyID
	let client
	let [data, setData] = useState({})
	let [ready, setReady] = useState(false)
	const setPipsyClient = useStoreActions((actions) => actions.setPipsyClient)
	const setSelections = useStoreActions((actions) => actions.setSelections)
	const setMode = useStoreActions((actions) => actions.setMode)
	const setViewing = useStoreActions((actions) => actions.setViewing)
	const setProperty = useStoreActions((actions) => actions.setProperty)
	const showMap = useStoreState((state) => state.showMap)
	const pid = useStoreState((state) => state.propertyID)
	const [rootPosition, setRootPosition] = useState(0)
	if (url.includes("localhost") && url.includes("1234")) {
		const urlParams = new URLSearchParams(window.location.search)
		let str = urlParams.get("property")
		let prop = str.split("-")
		client = prop[0]
		propertyID = prop[1]
		if (pid !== propertyID) setProperty(propertyID)
		// check for special mode like area-features
		let modeCheck = urlParams.get("mode")
		if (!modeCheck) {
			modeCheck = document.getElementById("pipsy__inventory").getAttribute("data-mode")
		}
		if (modeCheck) {
			setMode(modeCheck)
			if (modeCheck === "lot_finder") setViewing("lot_finder")
		}
	} else {
		// dev url
		let params = document.getElementById("pipsy__inventory").getAttribute("data-id")
		let modeCheck = document.getElementById("pipsy__inventory").getAttribute("data-mode")

		let parts = params.split("-")
		//let params = new URLSearchParams(document.location.search.substring(1))
		//propertyID = params.get("property")
		client = parseInt(parts[0])
		propertyID = parseInt(parts[1])
		setProperty(propertyID)
		if (modeCheck) {
			setMode(modeCheck)
			if (modeCheck === "lot_finder") setViewing("lot_finder")
		}
	}

	useEffect(() => {
		// Modify the meta viewport so the scale cannot go past 1.0
		try {
			const meta = document.getElementsByTagName("meta")
			if (meta.viewport) meta.viewport.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0"
		} catch (e) {}
		async function fetch() {
			let resp
			if (["localhost", "192.168"].includes(window.location.hostname) && url?.includes("1234")) {
				//resp = await axios.get(`http://192.168.7.111:9000/processProperty/${client}-${propertyID}`)
				resp = await axios.get(`http://localhost:9000/processProperty/${client}-${propertyID}`)
			} else if (window.location.hostname.includes("0.0.0.0")) {
				resp = await axios.get(`http://0.0.0.0:9000/processProperty/${client}-${propertyID}`)
			} else {
				resp = await axios.get(`https://public1.pipsy.io/payloads/${client}-${propertyID}.json`)
			}
			// If this property doesnt' sell dirt lots, show dirt as unavailable.
			if (get(resp.data, `property.disabled.dirtLots`)) {
				forEach(resp.data.mapLots, (v) => {
					if (v.lot_status == "Available Lot") v.lot_status = "Developer"
				})
			}
			// Set amenities to true for welcome centers
			if (window.location.href.includes("/welcome")) {
				set(resp.data, `property.amenities`, true)
			}
			//console.log(resp.data)
			setData(resp.data)
			setPipsyClient(client)
			setReady(true)
		}
		fetch()
		try {
			setRootPosition(offset(document.querySelector("#pipsyRoot")).top)
		} catch (e) {}
		//? If we find utm params, store in local storage so we can pass in with the contact form
		//  This will overwrite any existing utm params.  The last one is probably the most important?
		try {
			const urlParams = new URLSearchParams(window.location.search)
			let check = {}
			if (urlParams.get("utm_source")) check.source = urlParams.get("utm_source")
			if (urlParams.get("utm_medium")) check.medium = urlParams.get("utm_medium")
			if (urlParams.get("utm_campaign")) check.campaign = urlParams.get("utm_campaign")
			if (urlParams.get("utm_term")) check.term = urlParams.get("utm_term")
			if (urlParams.get("utm_content")) check.content = urlParams.get("utm_content")
			if (!isEmpty(check)) localStorage.setItem("pipsy__utm", JSON.stringify(check))
		} catch (e) {}
	}, [])

	function offset(el) {
		var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	}

	function stickyHeight() {
		// This method attemps to lock the inventory app to the top of the screen below the fixed nav while scrolling to prevent undesirable scrolling where people scroll past the filters.  We assign the root height so it doesn't jump when it goes to fixed, since fixed elements are removed from the flow of the document.
		try {
			let disableCheck = document.getElementById("pipsy__inventory").getAttribute("disableSticky")
			if (disableCheck) return
			let navClasses = ["header.fixed", "header.is-fixed", "div.header-container", "header.header-container"]
			let navHeight
			navClasses.every((c) => {
				// attempt to find the nav element
				let nav = document.querySelector(c)
				if (nav) {
					navHeight = nav.offsetHeight
					return false
				}
				return true
			})
			if (!navHeight) return
			let root = document.querySelector("#pipsyRoot")
			let global = document.querySelector(".pipsy__global")
			let toolsHeight = document.querySelector(".pipsy__toolsGlobal").offsetHeight
			//let viewHeight = document.querySelector(".pipsy__globalView").offsetHeight
			let globalView = document.querySelector(".pipsy__globalView")
			let windowHeight = window.outerHeight
			if (window.outerWidth < 992) {
				global.style.top = "auto"
				global.style.position = "relative"
				root.style.height = "auto"
				return
			}
			let rootHeight = windowHeight - navHeight
			let y = window.scrollY
			if (navHeight && rootHeight) {
				root.style.height = rootHeight + "px"
				if (y + navHeight >= rootPosition) {
					let totalHeight = windowHeight - toolsHeight - navHeight
					/* console.table([
						{
							rootHeight,
							navHeight,
							y,
							rootPosition,
							toolsHeight,
							//viewHeight,
							windowHeight,
							totalHeight
						},
					]) */
					global.style.top = navHeight + "px"
					global.style.position = "fixed"
					global.style.width = "100%"
					global.style.height = totalHeight + "px"
					global.style.backgroundColor = "white"
					global.style.zIndex = "50"
					global.style.boxSizing = "content-box"
					global.style.paddingBottom = "30px" // this is safety ot ensure the bottom is covered
					globalView.style.height = totalHeight - 130 + "px"
					//globalView.style.height = totalHeight + "px"
				} else if (y + navHeight < rootPosition) {
					global.style.top = "auto"
					global.style.height = "auto"
					global.style.position = "relative"
				}
			}
		} catch (e) {}
	}

	window.onscroll = function () {
		stickyHeight()
	}

	const View = styled.div`
		${hb.sm`
			min-height: 75vh;
		`}
		${hb.md`
			min-height: 70vh;
		`}
		${hb.lg`
			padding-top:0;
		`}
		${wb.lg`
			border-top:1px solid #e8e8e8;
			${() => {
				// Map
				if (showMap) {
					return `
						height: 100vh;
						display: grid;
						grid-template-columns: 50% 50%;
					`
				}
				// no map
				else {
					return `
						min-height: 90vh;
					`
				}
			}}
		`}
	`

	function InventoryGlobal({ props }) {
		const buildersDropdown = useRef()
		const sitesDropdown = useRef()
		const lotTypesDropdown = useRef()
		const neighborhoodsDropdown = useRef()
		let [theme, setTheme] = useState({
			color: "",
			lightGray: "#bbb",
			gray: "#444",
			darkGray: "#222",
		})
		const showMap = useStoreState((state) => state.showMap)
		const domain = useStoreState((state) => state.domain)
		const pipsyClient = useStoreState((state) => state.pipsyClient)
		const propertyID = useStoreState((state) => state.propertyID)
		const manualMapShow = useStoreState((state) => state.manualMapShow)
		const selections = useStoreState((state) => state.selections)
		const largeDevice = useStoreState((state) => state.largeDevice)
		const viewingFavorites = useStoreState((state) => state.viewingFavorites)
		const mobileContactOpen = useStoreState((state) => state.mobileContactOpen)
		const favorites = useStoreState((state) => state.favorites)
		const activePanel = useStoreState((state) => state.activePanel)
		const lastEvent = useStoreState((state) => state.lastEvent)
		const setLastEvent = useStoreActions((actions) => actions.setLastEvent)
		const setSelectedAreaFeatures = useStoreActions((actions) => actions.setSelectedAreaFeatures)
		const setSelections = useStoreActions((actions) => actions.setSelections)
		const matchedList = useStoreState((state) => state.matchedList)
		const setFavorites = useStoreActions((actions) => actions.setFavorites)
		const setViewing = useStoreActions((actions) => actions.setViewing)
		const setAllHomes = useStoreActions((actions) => actions.setAllHomes)
		const setViewingFavorites = useStoreActions((actions) => actions.setViewingFavorites)
		const setShowMap = useStoreActions((actions) => actions.setShowMap)
		const setMoveIn = useStoreActions((actions) => actions.setMoveIn)
		const setUnderConst = useStoreActions((actions) => actions.setUnderConst)

		const setActiveLot = useStoreActions((actions) => actions.setActiveLot)
		const setActivePanel = useStoreActions((actions) => actions.setActivePanel)
		const setProperty = useStoreActions((actions) => actions.setProperty)
		const allHomes = useStoreState((state) => state.allHomes)
		const isMobile = useStoreState((state) => state.isMobile)
		const mode = useStoreState((state) => state.mode)
		const moveIn = useStoreState((state) => state.moveIn)
		const underConst = useStoreState((state) => state.underConst)
		const premiumHomesites = useStoreState((state) => state.premiumHomesites)
		const builderOwnedHomesites = useStoreState((state) => state.builderOwnedHomesites)
		const setIsMobile = useStoreActions((actions) => actions.setIsMobile)
		const setLargeDevice = useStoreActions((actions) => actions.setLargeDevice)
		const setDomain = useStoreActions((actions) => actions.setDomain)
		const viewing = useStoreState((state) => state.viewing)
		const selectedAreaFeatures = useStoreState((state) => state.selectedAreaFeatures)
		const setMatchedList = useStoreActions((actions) => actions.setMatchedList)
		const setUnmatchedList = useStoreActions((actions) => actions.setUnmatchedList)
		let [marks, setMarks] = useState({})
		let [ranges, setRanges] = useState({ price: [] })
		let [loaded, setLoaded] = useState(false)
		let [ready, setReady] = useState(false)
		let [originalSelections, setOriginalSelections] = useState({})
		let [originalMarks, setOriginalMarks] = useState({})
		let [defaultMarks, setDefaultMarks] = useState({})
		let [originalRanges, setOriginalRanges] = useState({})
		let [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)
		const [filterBuilderOpen, setFilterBuilderOpen] = useState(false)
		const [filterNeighborhoodOpen, setFilterNeighborhoodOpen] = useState(false)
		const [filterLotTypeOpen, setFilterLotTypeOpen] = useState(false)
		const [filterSites, setFilterSites] = useState(false)
		let options = {
			price_range: [
				{
					id: 1,
					title: `$200,000 - $249,999`,
					min: 200000,
					max: 249999,
				},
				{
					id: 2,
					title: `$250,000 - $299,999`,
					min: 250000,
					max: 299999,
				},
				{
					id: 3,
					title: `$300,000 - $349,999`,
					min: 300000,
					max: 349999,
				},
				{
					id: 4,
					title: `$350,000 - $399,999`,
					min: 350000,
					max: 399999,
				},
				{
					id: 5,
					title: `$400,000 - $449,999`,
					min: 400000,
					max: 449999,
				},
				{
					id: 6,
					title: `$450,000 - $499,999`,
					min: 450000,
					max: 499999,
				},
				{
					id: 7,
					title: `$500,000 - $549,999`,
					min: 500000,
					max: 549999,
				},
				{
					id: 8,
					title: `$550,000 - $599,999`,
					min: 550000,
					max: 599999,
				},
				{
					id: 9,
					title: `$600,000 - $649,999`,
					min: 600000,
					max: 649999,
				},
				{
					id: 10,
					title: `$650,000 - $699,999`,
					min: 650000,
					max: 699999,
				},
				{
					id: 11,
					title: `$700,000 - $749,999`,
					min: 700000,
					max: 749999,
				},
				{
					id: 12,
					title: `$750,000 - $799,999`,
					min: 750000,
					max: 799999,
				},
			],
			sqft: [
				{ id: 1, title: "1,500 - 1,999", min: 1500, max: 1999 },
				{ id: 2, title: "2,000 - 2,499", min: 2000, max: 2499 },
				{ id: 3, title: "2,500 - 2,999", min: 2500, max: 2999 },
				{ id: 4, title: "3,000 - 3,499", min: 3000, max: 3499 },
				{ id: 5, title: "3,500 - 3,999", min: 3500, max: 3999 },
				{ id: 6, title: "4,000 - 4,499", min: 4000, max: 4499 },
				{ id: 7, title: "4,500 - 4,999", min: 4500, max: 4999 },
				{ id: 8, title: "5,000 - 5,499", min: 5000, max: 5499 },
				{ id: 9, title: "5,500 - 5,999", min: 5500, max: 5999 },
				{ id: 10, title: "6,000 - 6,499", min: 6000, max: 6499 },
				{ id: 11, title: "6,500+", min: 6500, max: 99999 },
			],
			beds: [
				{ id: 2, title: "2+" },
				{ id: 3, title: "3+" },
				{ id: 4, title: "4+" },
				{ id: 5, title: "5+" },
				{ id: 6, title: "6+" },
			],
			baths: [
				{ id: 2, title: "2+" },
				{ id: 3, title: "3+" },
				{ id: 4, title: "4+" },
				{ id: 5, title: "5+" },
				{ id: 6, title: "6+" },
			],
			stories: [
				{ id: 1, title: "1" },
				{ id: 2, title: "2" },
			],
		}

		const changedWindowSize = () => {
			//
			if (window.innerWidth < 992) {
				//
				setIsMobile(true)
			} else {
				//
				setIsMobile(false)
			}

			if (window.innerWidth > 1500 && window.innerHeight > 900) {
				setLargeDevice(true)
			}
		}

		const URLParams = (selections) => {
			// This takes URL params and applies on component load, like price, beds, baths, etc.
			let params = new URLSearchParams(window.location.search)
			let o = {
				price: params.get("price"),
				builders: params.get("builders"),
				beds: params.get("beds"),
				baths: params.get("baths"),
				sqft: params.get("sqft"),
				stories: params.get("stories"),
				lot_types: params.get("lot_types"),
				neighborhoods: params.get("neighborhoods"),
				marketing_home_types: params.get("marketing_home_types"),
			}
			//? Translate english lot types to ids
			if (o.lot_types) {
				let lot_types = []
				forEach(o.lot_types.split(","), (v) => {
					let type = find(data.property.active_lot_types, { name: v })
					if (type) lot_types.push(type.id)
					else console.log(`Could not find lot type ${v} in active_lot_types.`)
				})
				o.lot_types = lot_types
			}
			const typed = (arr) => {
				return arr.map((v) => parseInt(v))
			}
			forEach(o, (v, k) => {
				if (v) {
					try {
						o[k] = o[k].split(",")
						if (o[k] && typeof o[k] == "object" && ["lot_types", "marketing_home_types"].includes(k)) {
							//o[k] = o[k]
							//skip
						} else if (o[k] && typeof o[k] == "object" && o[k].length == 2) {
							o[k] = typed(o[k])
						} else if (o[k] && typeof o[k] == "object" && k == "builders") {
							o[k] = typed(o[k])
						} else if (k === "neighborhoods") {
							o[k] = typed(o[k])
						} else throw `Issue with ${k} formatting.`
					} catch (e) {}
				}
			})
			forEach(o, (v, k) => {
				if (v) {
					selections[k] = v
				}
			})
			// Lastly, check for builders on the tag - originally used in lot_finder, but can be used elsewhere
			let builders = document.getElementById("pipsy__inventory").getAttribute("data-builders")
			if (builders) {
				let builderArray = builders.split(",")
				builderArray = map(builderArray, (v) => parseInt(v))
				selections.builders = builderArray
			}
			//? if builders is set, check and see if the available homes is 0.  If it is, set the viewing to floorplans
			if (selections.builders && selections.builders.length > 0) {
				let available = 0
				forEach(data.available, (v) => {
					if (selections.builders.includes(v.builder_id) && v.price) available++
				})
				if (available == 0) {
					setViewing("floorplans")
				}
			}
			let neighborhoods = document.getElementById("pipsy__inventory").getAttribute("data-neighborhoods")
			if (neighborhoods) {
				let neighArrray = neighborhoods.split(",")
				neighArrray = map(neighArrray, (v) => parseInt(v))
				selections.neighborhoods = neighArrray
			}
			if (selections.neighborhoods && selections.neighborhoods.length > 0) {
				let available = 0
				forEach(data.available, (v) => {
					if (selections.neighborhoods.includes(v.neighborhood_id) && v.price) available++
				})
				if (available == 0) {
					setViewing("lot_finder")
				}
			}
			return selections
		}

		useEffect(() => {
			window.onresize = changedWindowSize
			changedWindowSize()
			async function fetchData() {
				if (["area_features"].includes(mode)) setViewing(mode)
				else if (data?.available?.length === 0 && data?.floorplans?.length == 0 && data?.models?.length === 0)
					setViewing("lot_finder")
				else if (data?.available?.length === 0 && data?.floorplans?.length == 0) setViewing("models")
				else if (data?.available?.length === 0) setViewing("floorplans")
				let color = data.property.color
				let themeClone = cloneDeep(theme)
				themeClone.color = color
				themeClone.secondary_color = data.property.secondary_color
				themeClone.accent_color = data.property.accent_color
				themeClone.secondaryEnabled = get(data, `property.enabled.secondaryColor`)
				themeClone.tertiaryEnabled = get(data, `property.enabled.tertiaryColor`)
				themeClone.amenities = get(data, `property.amenities`)
				themeClone.openHouses = get(data, `property.enabled.openHouses`)
				themeClone.noMap = !showMap
				// Compile builders and put them into selected builders
				//? Find high and low price points
				//? Prices
				let prices = []
				let fpprices = []
				forEach(data.available, (v) => {
					if (v.price) prices.push(v.price)
				})
				forEach(data.models, (v) => {
					if (v.price) prices.push(v.price)
				})
				forEach(data.floorplans, (v) => {
					if (v.price) fpprices.push(v.price)
				})
				prices = [...prices, ...fpprices]
				let lowPrice = min(prices)
				let highPrice = max(prices)
				// Round to nearest 10k for stepping
				lowPrice = Math.floor(lowPrice / 10000) * 10000
				highPrice = Math.ceil(highPrice / 10000) * 10000
				//? Acreage
				let acreage = []
				forEach(data.mapLots, (v) => {
					if (v.acreage) acreage.push(v.acreage)
				})
				let lowAcreage = min(acreage)
				let highAcreage = max(acreage)
				//? High and low square footage
				let sqft = []
				let fpsqft = []
				forEach(data.available, (v) => {
					if (v.sqft) sqft.push(v.sqft)
				})
				forEach(data.floorplans, (v) => {
					if (v.sqft) fpsqft.push(v.sqft)
				})
				sqft = [...sqft, ...fpsqft]
				let lowSqft = min(sqft)
				let highSqft = max(sqft)
				lowSqft = Math.floor(lowSqft / 100) * 100
				highSqft = Math.ceil(highSqft / 100) * 100
				//? High and low beds
				let beds = []
				let fpbeds = []
				forEach(data.available, (v) => {
					if (v.beds) beds.push(v.beds)
				})
				forEach(data.models, (v) => {
					if (v.beds) beds.push(v.beds)
				})
				forEach(data.floorplans, (v) => {
					if (v.beds) fpbeds.push(v.beds)
				})
				beds = [...beds, ...fpbeds]
				let lowBeds = min(beds)
				let highBeds = max(beds)
				//? High and low baths
				let baths = []
				let fpbaths = []
				forEach(data.available, (v) => {
					if (v.full_baths) baths.push(v.full_baths)
				})
				forEach(data.models, (v) => {
					if (v.full_baths) baths.push(v.full_baths)
				})
				forEach(data.floorplans, (v) => {
					if (v.full_baths) fpbaths.push(v.full_baths)
				})
				baths = [...baths, ...fpbaths]
				let lowBaths = min(baths)
				let highBaths = max(baths)
				//? High and low stories
				let stories = []
				let fpstories = []
				forEach(data.available, (v) => {
					if (v.stories) stories.push(v.stories)
				})
				forEach(data.floorplans, (v) => {
					if (v.stories) fpstories.push(v.stories)
				})
				stories = [...stories, ...fpstories]
				let lowStories = min(stories)
				let highStories = max(stories)
				let selections = {
					builders: [],
					sites: [],
					lot_types: [],
					neighborhoods: [],
					marketing_home_types: [],
					price: [lowPrice, highPrice],
					sqft: [lowSqft, highSqft],
					beds: [lowBeds, highBeds],
					baths: [lowBaths, highBaths],
					stories: [lowStories, highStories],
					acreage: [lowAcreage, highAcreage],
				}
				let marks = {
					price: {
						[lowPrice]: numeral(lowPrice).format("0,0"),
						[highPrice]: numeral(highPrice).format("0,0"),
					},
					sqft: {
						[lowSqft]: numeral(lowSqft).format("0,0"),
						[highSqft]: numeral(highSqft).format("0,0"),
					},
					beds: {
						[lowBeds]: numeral(lowBeds).format("0,0"),
						[highBeds]: numeral(highBeds).format("0,0"),
					},
					baths: {
						[lowBaths]: numeral(lowBaths).format("0,0"),
						[highBaths]: numeral(highBaths).format("0,0"),
					},
					stories: {
						[lowStories]: numeral(lowStories).format("0[.]0"),
						[highStories]: numeral(highStories).format("0[.]0"),
					},
					acreage: {
						[lowAcreage]: numeral(lowAcreage).format("0[.]0"),
						[highAcreage]: numeral(highAcreage).format("0[.]0"),
					},
				}
				let defaultMarks = {
					price: [lowPrice, highPrice],
					sqft: [lowSqft, highSqft],
					beds: [lowBeds, highBeds],
					baths: [lowBaths, highBaths],
					stories: [lowStories, highStories],
					acreage: [lowAcreage, highAcreage],
				}
				let ranges = {
					price: [lowPrice, highPrice],
					sqft: [lowSqft, highSqft],
					beds: [lowBeds, highBeds],
					baths: [lowBaths, highBaths],
					stories: [lowStories, highStories],
					acreage: [lowAcreage, highAcreage],
				}
				let deepLink = () => {
					// Check for request to deep link to floorplan/home
					let params = new URLSearchParams(window.location.search)
					let floorplans = params.get("floorplans")
					let openHouses = params.get("openHouses")
					let models = params.get("models")
					let deep = {
						lot: params.get("address"),
						floorplan: params.get("floorplan"),
						lot_id: params.get("lot_id"),
					}
					if (deep.lot || deep.floorplan || deep.lot_id) {
						try {
							if (deep.lot) {
								let repl = deep.lot.replace("+", " ")
								let lookup = find(data.available, (v) => {
									return v.address.toLowerCase() === repl.toLowerCase()
								})
								if (lookup) {
									// available home
									setActivePanel(true)
									setActiveLot(lookup)
									setViewing("homes")
									fireEvent(
										{
											type: "listLotClick",
											data: lookup.address,
											name: null,
										},
										lastEvent,
										setLastEvent,
										{ domain, pipsyClient, propertyID }
									)
								}
								if (!lookup) {
									lookup = find(data.mapLots, (v) => {
										return v.address.toLowerCase() === repl.toLowerCase()
									})
									if (lookup) {
										// dirt lot
										setActivePanel(true)
										setActiveLot(lookup)
										setViewing("lot_finder")
										fireEvent(
											{
												type: "listLotClick",
												data: lookup.address,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}
								}
								// Hasn't found yet, check model
								lookup = find(data.models, (v) => {
									return v.address.toLowerCase() === repl.toLowerCase()
								})
								if (lookup) {
									setActivePanel(true)
									setActiveLot(lookup)
									setViewing("models")
								}
							} else if (deep.floorplan) {
								let repl = deep.floorplan.replace("+", " ")
								const lookup = find(data.floorplans, (v) => {
									let name = v.feed_name ? v.feed_name : v.name
									return name.toLowerCase() === repl.toLowerCase()
								})
								if (lookup) {
									setActivePanel(true)
									setActiveLot(lookup)
									setViewing("floorplans")
								}
							} else if (deep.lot_id) {
								let lookup = find(data.mapLots, (v) => {
									return v.id == deep.lot_id
								})
								if (lookup) {
									setActivePanel(true)
									setActiveLot(lookup)
									setViewing("lot_finder")
								}
							}
						} catch (e) {}
					}
					if (floorplans) {
						setViewing("floorplans")
					} else if (openHouses) setViewing("openHouses")
					else if (models) setViewing("models")
				}
				deepLink()
				selections.builders = map(data.property.builders, (v) => v.id)
				selections.lot_types = map(data.property.active_lot_types, (v) => v.id)
				selections.neighborhoods = map(data.neighborhoods, (v) => v.id)
				// check for url params and override if they are set
				let originalMarks = cloneDeep(marks)
				let originalSelections = cloneDeep(selections)
				let originalRanges = cloneDeep(ranges)
				let allHomes = has(data, `available`) ? data.available : []
				selections = URLParams(selections) // This is purposefully after the original selections are set as that's whats used in the reset.
				let builderID = document.getElementById("pipsy__inventory").getAttribute("data-builder")
				//? if data-builder is on the div id, set the builders to that
				if (builderID) {
					selections.builders = [parseInt(builderID)]
				}
				if (document.getElementById("pipsy__inventory").getAttribute("data-moveIn")) {
					setMoveIn(true)
					setUnderConst(false)
				} else if (document.getElementById("pipsy__inventory").getAttribute("data-underConstruction")) {
					setMoveIn(false)
					setUnderConst(true)
				}
				setAllHomes(allHomes)
				setDomain(data.domain)
				setTheme(themeClone)
				setSelections(selections)
				setMarks(marks)
				setRanges(ranges)
				setReady(true)
				setOriginalSelections(originalSelections)
				setDefaultMarks(defaultMarks)
				setOriginalRanges(originalRanges)
				setOriginalMarks(originalMarks)
				// Set community color on html root to access from mapbox for popup styling
				document.querySelector(":root").style.setProperty("--pipsy-communityColor", themeClone.color)
				if (themeClone?.accent_color) {
					document.querySelector(":root").style.setProperty("--pipsy-accentColor", themeClone.accent_color)
				}
				document
					.querySelector(":root")
					.style.setProperty("--pipsy-secondaryCommunityColor", themeClone.secondary_color)
				if (get(data, `property.enabled.noBuilder`)) setViewing("lot_finder") // selling lots directly to prospects like willowcreek
			}

			fetchData()
			// Override map showing
			const gets = new URLSearchParams(window.location.search)
			const mapOverride = gets.get("showMap")
			let mapShow = true
			if (get(data, `custom.noMap`)) mapShow = false
			if (mapOverride) mapShow = true
			if (manualMapShow === false) mapShow = false

			setShowMap(mapShow)
			// Get favorites if they exist
			let favorites = localStorage.getItem("pipsy__favorites")
				? JSON.parse(localStorage.getItem("pipsy__favorites"))
				: []
			setFavorites(favorites)

			setProperty(propertyID)
			let cats = map(props.area_features, (v) => v.category)
			cats = uniq(cats)
			cats.sort()
			setSelectedAreaFeatures(cats)
			/* setTimeout(() => {
				setLoaded(true)
			}, 1000) */
			setLoaded(true)
		}, [])

		useEffect(() => {
			cleanupFavorites()
		}, [allHomes])

		useEffect(() => {}, [isMobile])

		const cleanupFavorites = () => {
			// Goes through the local storage and finds homes that are no longer in the available homes and removes from the users favorites.
			if (allHomes.length == 0) return
			let current = localStorage.getItem("pipsy__favorites") ? localStorage.getItem("pipsy__favorites") : []
			if (current.length == 0) {
				return
			}
			let f = []
			current = JSON.parse(current)
			forEach(current, (v) => {
				let id = v.replace("h-", "")
				id = parseInt(id)
				if (find(allHomes, { id })) {
					f.push(`h-${id}`)
				}
			})
			localStorage.setItem("pipsy__favorites", JSON.stringify(f))
		}

		const storeFavorite = (val) => {
			// get current prefs
			let current = localStorage.getItem("pipsy__favorites") ? localStorage.getItem("pipsy__favorites") : []
			if (!isEmpty(current)) {
				current = JSON.parse(current)
			}
			current.push(val)
			current = uniq(current)
			localStorage.setItem("pipsy__favorites", JSON.stringify(current))
			setFavorites(current)
		}

		const removeFavorite = (val) => {
			// get current prefs
			let current = localStorage.getItem("pipsy__favorites") ? localStorage.getItem("pipsy__favorites") : []
			if (!isEmpty(current)) {
				current = JSON.parse(current)
				current = filter(current, (v) => val !== v)
			}

			localStorage.setItem("pipsy__favorites", JSON.stringify(current))
			setFavorites(current)
		}

		const flip = (id, type) => {
			let sel = clone(selections)
			if (includes(sel[type], id)) {
				pull(sel[type], id)
			} else {
				sel[type].push(id)
			}

			setSelections(sel)
		}

		let calcData = (name) => {
			let ret = {}
			let low = min(selections[name])
			let high = max(selections[name])
			low = find(options[name], { id: low })
			high = find(options[name], { id: high })
			ret.min = low ? low.min : 0
			ret.max = high ? high.max : 0

			return ret
		}

		let buildMatchLists = (opts) => {
			// Determine selections
			//? internalviewing was added when we began using this method as either a setter of matchedList or if trying to determine the counters view count.  Used to access viewing directly, but had to make this modification for calcs
			let internalViewing = viewing
			if (opts && opts.justCount && opts.viewing) {
				internalViewing = opts.viewing
			}
			let store = {
				builders: selections.builders,
				neighborhoods: selections.neighborhoods,
				sites: selections.sites,
				price_range: {
					min: 0,
					max: 0,
				},
				sqft: {
					min: 1500,
					max: 99999,
				},
				beds: 2,
				baths: 2,
			}

			// check this lot matches selections
			// first prices
			store.price_range = calcData("price_range")
			store.sqft = calcData("sqft")
			store.beds = min(selections.beds) || 2
			store.baths = min(selections.baths) || 2

			let noBuilder = get(data, `property.enabled.noBuilder`) // This is for the likes of willowcreek, selling lots directly to prospects community wide

			//! Does every developer want move in ready always first?
			let set
			if (internalViewing == "homes" || internalViewing == "openHouses") {
				set = cloneDeep(data.available)
			} else if (internalViewing == "floorplans") {
				set = cloneDeep(data.floorplans)
			} else if (internalViewing == "amenities" || internalViewing == "area_features") {
				set = cloneDeep(data.area_features)
			} else if (internalViewing == "models") {
				set = cloneDeep(data.models)
				set = filter(set, (r) => r.model_show_in_feed)
			} else if (internalViewing == "lot_finder") {
				set = cloneDeep(data.mapLots)
				if (!noBuilder) set = filter(set, (r) => r.lot_status == "Available Lot")
				else set = filter(set, (r) => !["Contract", "Closed"].includes(r.lot_status))
				// Remove in feed manuals
				set = filter(set, (r) => {
					if (r.in_feed_manual === false || r.in_feed_manual === 0) return false
					return true
				})
			}
			let matched = []
			let unmatched = []
			if (internalViewing == "area_features") {
				forEach(set, (v) => {
					if (!v.amenity) matched.push(v)
				})
			} else if (internalViewing == "amenities") {
				forEach(set, (v) => {
					if (v.amenity) matched.push(v)
				})
			} else if (internalViewing == "openHouses") {
				// open_hosue is only in available
				forEach(set, (v) => {
					let homeOpt = internalViewing == "homes" || internalViewing == "openHouses"
					//! These are all the conditions to skip
					try {
						if (
							(homeOpt &&
								selections.lot_types.length > 0 &&
								!selections.lot_types.includes(v.lot_type_id)) ||
							(homeOpt &&
								selections.marketing_home_types.length > 0 &&
								!selections.marketing_home_types.includes(v.marketing_home_type)) ||
							!store.builders.includes(v.builder_id) ||
							!v.open_house ||
							(v.open_house && Array.isArray(v.open_house) && v.open_house.length == 0)
						) {
							unmatched.push(v)
							return
						}
						matched.push(v)
					} catch (e) {}
				})
				// unmatch all other lots except ones in matched already
				forEach(data.mapLots, (v) => {
					let f = find(matched, { id: v.id })
					if (!f) unmatched.push(v)
				})
			} else if (internalViewing == "models") {
				forEach(set, (v) => {
					let favoriteID = `h-${v.id}`
					//! These are all the conditions to skip
					if (
						selections.lot_types.length === 0 ||
						(selections.lot_types.length > 0 && !selections.lot_types.includes(v.lot_type_id)) ||
						!store.builders.includes(v.builder_id) ||
						(viewingFavorites && !favorites.includes(favoriteID))
					) {
						unmatched.push(v)
						return
					}
					matched.push(v)
				})
				// Also need to unmatch all the available lots
				forEach(data.available, (v) => {
					let f = find(matched, { id: v.id })
					if (!f) unmatched.push(v)
				})
				forEach(data.mapLots, (v) => {
					let f = find(matched, { id: v.id })
					if (!f) unmatched.push(v)
				})
			} else if (internalViewing == "lot_finder") {
				if (noBuilder) {
					// All lots that are not closed/contract are in set, so just match them all.  This is for selling lots directly to prospects
					matched = set
				} else {
					forEach(set, (v) => {
						let favoriteID = `h-${v.id}`
						//! These are all the conditions to skip
						if (
							selections.lot_types.length === 0 ||
							(selections.lot_types.length > 0 && !selections.lot_types.includes(v.lot_type_id)) ||
							!store.builders.includes(v.builder_id) ||
							!store.neighborhoods.includes(v.neighborhood_id) ||
							(selections?.sites &&
								selections.sites?.length > 0 &&
								(!v.site_id ||
									(Array.isArray(v.site_id) &&
										!v.site_id.some((id) => selections.sites.includes(id))))) ||
							(viewingFavorites && !favorites.includes(favoriteID)) ||
							(data?.property?.enabled?.premiumHomesites && !premiumHomesites && v.is_premium) ||
							(data?.property?.enabled?.premiumHomesites &&
								!builderOwnedHomesites &&
								v.builder &&
								!v.is_premium)
						) {
							unmatched.push(v)
							return
						}
						matched.push(v)
					})
					// Also need to unmatch all the available lots
					forEach(data.available, (v) => {
						let f = find(matched, { id: v.id })
						if (!f) unmatched.push(v)
					})
					forEach(data.mapLots, (v) => {
						let f = find(matched, { id: v.id })
						if (!f) unmatched.push(v)
					})
				}
			} else {
				// homes or open houses or fps
				//? Instances where models are for sale but still models
				if (["homes", "models"].includes(internalViewing)) {
					/* forEach(data.models, (v) => {
					if (v.price && !v.sale_id && (v.in_feed || v.in_feed_manual)) {
						set.push(v)
					}
				}) */
				}
				//? Floorplan "price" field is figured out on teh server - uses base price, community price, or regular price field.
				set = sortBy(set, "price")
				forEach(set, (v) => {
					if (v.model && !v.price) return
					let favoriteID = internalViewing == "floorplans" ? `f-${v.id}` : `h-${v.id}`
					if (data?.property?.forceLotStatusByMoveInDate) {
						//? Sometimes homes do not have completes (salespeople...) but they're past their move in date.  artificially make this home available now.  Johnson using only for now.
						if (!v.complete_date && v.move_in_date && Math.floor(Date.now() / 1000) > v.move_in_date) {
							v.lot_status = "Available Home"
						} else if (
							v.complete_date &&
							v.move_in_date &&
							v.move_in_date > Math.floor(Date.now() / 1000)
						) {
							// The move in date (usually from builder feed) is after the complete date we have on file, so mark this home as coming soon...basically prefer what the builder feed has over us.  May want to turn this on/off depending on the developer scenario.
							v.lot_status = "Coming Soon"
						}
					}
					// This homeopt is a shortcut for the conditions that would be on the homes or openhouses
					let homeOpt = internalViewing == "homes" || internalViewing == "openHouses"
					//! These are all the conditions to skip
					if (
						(homeOpt && v.price < selections.price[0]) ||
						(homeOpt && v.price > selections.price[1]) ||
						(homeOpt &&
							selections?.lot_types &&
							selections.lot_types?.length > 0 &&
							!selections.lot_types.includes(v.lot_type_id)) ||
						(homeOpt &&
							selections?.sites &&
							selections.sites?.length > 0 &&
							(!v.site_id ||
								(Array.isArray(v.site_id) &&
									!v.site_id.some((id) => selections.sites.includes(id))))) ||
						(homeOpt &&
							selections.marketing_home_types.length > 0 &&
							!selections.marketing_home_types.includes(v.marketing_home_type)) ||
						!store.builders.includes(v.builder_id) ||
						(homeOpt && !store.neighborhoods.includes(v.neighborhood_id)) ||
						v.sqft < selections.sqft[0] ||
						v.sqft > selections.sqft[1] ||
						v.beds < selections.beds[0] ||
						v.beds > selections.beds[1] ||
						v.stories < selections.stories[0] ||
						v.stories > selections.stories[1] ||
						v.full_baths < selections.baths[0] ||
						v.full_baths > selections.baths[1] ||
						(internalViewing == "openHouses" && !v.open_house) ||
						(homeOpt && !moveIn && v.lot_status == "Available Home") ||
						(homeOpt && !underConst && v.lot_status == "Coming Soon") ||
						(viewingFavorites && !favorites.includes(favoriteID)) ||
						(internalViewing === "floorplans" && v.status !== 1) ||
						(internalViewing === "floorplans" && v.price && v.price < selections.price[0]) ||
						(internalViewing === "floorplans" && v.price && v.price > selections.price[1])
					) {
						unmatched.push(v)
						return
					}
					matched.push(v)
				})
				// unmatch all dirt lots that aren't in the builders selected
				if (internalViewing === "homes" || internalViewing === "openHouses") {
					forEach(data.mapLots, (v) => {
						if (
							!store.builders.includes(v.builder_id) ||
							!store.neighborhoods.includes(v.neighborhood_id) ||
							(selections?.sites &&
								selections.sites?.length > 0 &&
								(!v.site_id ||
									(Array.isArray(v.site_id) &&
										!v.site_id.some((id) => selections.sites.includes(id)))))
						) {
							unmatched.push(v)
							return
						}
					})
				}
			}
			if (opts?.returnList) return matched
			if (opts?.justCount) return matched.length
			setMatchedList(matched)
			setUnmatchedList(unmatched)
		}

		const outputBuilders = () => {
			let ret = []
			forEach(data.property.marketing_active_builders, (v) => {
				try {
					let p = find(data.property.builders, { id: v })
					//let count = []
					let count = []
					if (viewing === "floorplans") count = filter(matchedList, { builder_id: v })
					else if (viewing === "lot_finder") {
						count = filter(data.mapLots, (r) => r.builder_id == v && r.lot_status == "Available Lot")
					} else if (viewing === "homes") {
						let set = buildMatchLists({ viewing: "homes", returnList: true })
						count = filter(set, (r) => {
							// This is for Airia originally.  They set things to dirt but still show up as available..
							if (props?.custom?.personalize?.marketingUseManual && r.builder_id == v && r.price) {
								return true
							}
							if (
								r.builder_id == v &&
								r.price &&
								(r.lot_status == "Coming Soon" || r.lot_status === "Available Home")
							) {
								return true
							}
						})
					} else {
						count = filter(allHomes, { builder_id: v })
					}
					// add for sale models to count

					let opacity = selections.builders.includes(v) ? 1 : 0
					ret.push(
						<React.Fragment key={`builder-${v}`}>
							<li
								data-id={v}
								className="py-[2px] hover:opacity-80 transition-opacity duration-200"
								onClick={() => {
									try {
										let type = "builder__select"
										if (selections?.builders?.includes(v)) type = "builder__deselect"
										fireEvent(
											{
												type,
												data: p.name,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									} catch (e) {
										console.log(e)
									}
									flip(v, "builders")
								}}>
								<FontAwesomeIcon
									icon={faCheckCircle}
									style={{ marginRight: 5, opacity }}
									color={data.property.color}
								/>
								<BuilderName>{p.marketing_name ? p.marketing_name : p.name}</BuilderName>
								<BuilderCount>{count.length}</BuilderCount>
							</li>
						</React.Fragment>
					)
				} catch (e) {}
			})
			return ret
		}

		const outputSites = () => {
			let ret = []
			forEach(data.sites, (v) => {
				try {
					let count = []
					let set = buildMatchLists({ returnList: true })
					count = filter(set, (r) => {
						if (Array.isArray(r.site_id)) {
							return r.site_id.includes(v.id)
						}
						return r.site_id == v.id
					})
					// add for sale models to count
					let opacity = selections.sites.includes(v.id) ? 1 : 0
					ret.push(
						<React.Fragment key={`site-${v.id}`}>
							<li
								data-id={v.id}
								className="py-[2px] hover:opacity-80 transition-opacity duration-200"
								onClick={() => {
									try {
										let type = "site__select"
										if (selections?.sites?.includes(v)) type = "site__deselect"
										fireEvent(
											{
												type,
												data: v.name,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									} catch (e) {
										console.log(e)
									}
									flip(v.id, "sites")
								}}>
								<FontAwesomeIcon
									icon={faCheckCircle}
									style={{ marginRight: 5, opacity }}
									color={data.property.color}
								/>
								<BuilderName>{v.name}</BuilderName>
								<BuilderCount>{count.length}</BuilderCount>
							</li>
						</React.Fragment>
					)
				} catch (e) {
					console.log(e)
				}
			})
			return ret
		}

		const outputNeighborhoods = () => {
			let ret = []
			forEach(data.neighborhoods, (v) => {
				try {
					//let count = []
					let count = filter(
						data.mapLots,
						(r) => r.neighborhood_id == v.id && r.lot_status == "Available Lot"
					)
					if (viewing === "lot_finder")
						count = filter(data.mapLots, (r) => {
							return (
								r.neighborhood_id == v.id &&
								r.lot_status == "Available Lot" &&
								selections.builders.includes(r.builder_id)
							)
						})

					let opacity = selections.neighborhoods.includes(v.id) ? 1 : 0
					ret.push(
						<React.Fragment key={`neighborhood-${v.id}`}>
							<li
								data-id={v}
								className="py-[2px] hover:opacity-80 transition-opacity duration-200"
								onClick={() => {
									try {
										let ev = new Event("pipsy__filter")
										ev.pipsy__type = "neighborhood__select"
										if (
											selections &&
											Array.isArray(selections.neighborhoods) &&
											selections.neighborhoods.includes(v.id)
										) {
											ev.pipsy__type = "neighborhood__deselect"
										}
										ev.pipsy__data = v.name
										document.dispatchEvent(ev)
									} catch (e) {}
									flip(v.id, "neighborhoods")
								}}>
								<FontAwesomeIcon
									icon={faCheckCircle}
									style={{ marginRight: 5, opacity }}
									color={data.property.color}
								/>
								<BuilderName>{v.name}</BuilderName>
								<BuilderCount>{count.length}</BuilderCount>
							</li>
						</React.Fragment>
					)
				} catch (e) {}
			})
			return ret
		}

		const outputLotTypes = () => {
			let ret = []
			forEach(data.property.active_lot_types, (v) => {
				try {
					let id = v.id
					let count = filter(
						data.mapLots,
						(r) =>
							r.lot_type === v.name &&
							r.lot_status == "Available Lot" &&
							selections.builders.includes(r.builder_id)
					)
					let opacity = selections.lot_types.includes(id) ? 1 : 0
					ret.push(
						<React.Fragment key={`lotType-${id}`}>
							<li
								data-id={id}
								className="py-[2px] hover:opacity-80 transition-opacity duration-200"
								onClick={() => {
									try {
										let ev = new Event("pipsy__filter")
										ev.pipsy__type = "lotType__select"
										if (
											selections &&
											Array.isArray(selections.lot_types) &&
											selections.lot_types.includes(id)
										) {
											ev.pipsy__type = "lotType__deselect"
										}
										ev.pipsy__data = v.name
										document.dispatchEvent(ev)
									} catch (e) {}
									flip(id, "lot_types")
								}}>
								<FontAwesomeIcon
									icon={faCheckCircle}
									style={{ marginRight: 5, opacity }}
									color={data.property.color}
								/>
								<BuilderName>{v.name}</BuilderName>
								<BuilderCount>{count.length}</BuilderCount>
							</li>
						</React.Fragment>
					)
				} catch (e) {}
			})
			return ret
		}

		const reset = () => {
			let selections = cloneDeep(originalSelections)
			let ranges = cloneDeep(originalRanges)
			let marks = cloneDeep(originalMarks)
			setSelections(selections)
			setMarks(marks)
			try {
				let ev = new Event("pipsy__filter")
				ev.pipsy__type = "resetFilters"
				ev.pipsy__data = true
				document.dispatchEvent(ev)
			} catch (e) {}
		}

		const scrollToMap = () => {
			let el = document.getElementById("pipsy__map")
			if (el) {
				if (activePanel && isMobile) {
				} else {
					const y = el.getBoundingClientRect().top + window.pageYOffset - 40
					window.scrollTo({ top: y, behavior: "smooth" })
				}
			}
		}

		const displayStories = () => {
			if (get(props, `property.disabled.stories`)) return null
			return (
				<Option className="pipsy__optionStories" viewing={viewing}>
					<Label>STORIES</Label>
					<Range
						min={ranges.stories[0]}
						max={ranges.stories[1]}
						marks={marks.stories}
						step={0.5}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.stories}
						value={selections.stories}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.stories = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new stories...the keys are still the numbers of original low/high
							marksClone.stories[defaultMarks.stories[0]] = numeral(v[0]).format("0[.]0")
							marksClone.stories[defaultMarks.stories[1]] = numeral(v[1]).format("0[.]0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "stories",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displayBuilders = () => {
			if (get(props, `property.disabled.builders`)) return null
			if (mode === "builderDetail") return null
			return (
				<Option
					className="pipsy__optionBuilders"
					ref={buildersDropdown}
					viewing={viewing}
					key={`filters-builders`}
					onMouseEnter={() => setFilterBuilderOpen(true)}
					onMouseLeave={() => setFilterBuilderOpen(false)}>
					<OptionScreen
						onClick={() => {
							setFilterBuilderOpen(true)
						}}
					/>
					<label>BUILDERS</label>
					<SelectBuilders>Options&nbsp;&gt;</SelectBuilders>
					{filterBuilderOpen && (
						<OptionBox
							color={data.property.color}
							onMouseLeave={(e) => {
								// Check if still hovering over parent Option element
								const option = e.currentTarget.closest(".pipsy__optionBuilders")
								if (!option.matches(":hover")) {
									setFilterBuilderOpen(false)
								}
							}}>
							<OptionClose onClick={() => setFilterBuilderOpen(false)}>
								<FontAwesomeIcon icon={faTimesCircle} color={tertiaryColor()} />
							</OptionClose>
							<OptionList>
								{outputBuilders()}
								<li
									style={{
										paddingTop: 15,
										marginTop: 15,
										borderTop: `1px solid`,
										borderColor: tertiaryColor(),
									}}
									onClick={() => {
										let sel = clone(selections)
										sel.builders = map(data.property.builders, (v) => v.id)
										setSelections(sel)
										try {
											let ev = new Event("pipsy__filter")
											ev.pipsy__type = "builders__selectAll"
											document.dispatchEvent(ev)
										} catch (e) {}
									}}>
									Select All
								</li>
								<li
									onClick={() => {
										let sel = clone(selections)
										sel.builders = []
										setSelections(sel)
									}}>
									Deselect All
								</li>
								<SubmitBuilders onClick={() => setFilterBuilderOpen(false)}>SUBMIT</SubmitBuilders>
							</OptionList>
						</OptionBox>
					)}
				</Option>
			)
		}

		const displaySites = () => {
			if (!get(props, `property.enabled.sites`)) return null
			return (
				<Option
					className="pipsy__optionSites"
					ref={sitesDropdown}
					viewing={viewing}
					key={`filters-sites`}
					onMouseEnter={() => setFilterSites(true)}
					onMouseLeave={() => setFilterSites(false)}>
					<OptionScreen
						onClick={() => {
							setFilterSites(true)
						}}
					/>
					<label>Sites</label>
					<SelectBuilders>Options&nbsp;&gt;</SelectBuilders>
					{filterSites && (
						<OptionBox
							color={data.property.color}
							onMouseLeave={(e) => {
								// Check if still hovering over parent Option element
								const option = e.currentTarget.closest(".pipsy__optionSites")
								if (!option.matches(":hover")) {
									setFilterSites(false)
								}
							}}>
							<OptionClose onClick={() => setFilterSites(false)}>
								<FontAwesomeIcon icon={faTimesCircle} color={tertiaryColor()} />
							</OptionClose>
							<OptionList>
								{outputSites()}
								{selections.sites.length > 0 && (
									<li
										onClick={() => {
											let sel = clone(selections)
											sel.sites = []
											setSelections(sel)
										}}>
										<span className="block text-white bg-slate-800 text-center py-1 text-xs mt-4">
											Reset to All
										</span>
									</li>
								)}
								{/* <li
									style={{
										paddingTop: 15,
										marginTop: 15,
										borderTop: `1px solid`,
										borderColor: tertiaryColor(),
									}}
									onClick={() => {
										let sel = clone(selections)
										sel.sites = map(data.sites, (v) => v.id)
										setSelections(sel)
										try {
											let ev = new Event("pipsy__filter")
											ev.pipsy__type = "sites__selectAll"
											document.dispatchEvent(ev)
										} catch (e) {}
									}}>
									Select All
								</li>
								<li
									onClick={() => {
										let sel = clone(selections)
										sel.sites = []
										setSelections(sel)
									}}>
									Deselect All
								</li> */}
								<SubmitBuilders onClick={() => setFilterSites(false)}>SUBMIT</SubmitBuilders>
							</OptionList>
						</OptionBox>
					)}
				</Option>
			)
		}

		const displayNeighborhoods = () => {
			if (get(props, `property.disabled.neighborhoods`)) return null
			return (
				<Option
					className="pipsy__optionNeighborhoods"
					ref={neighborhoodsDropdown}
					viewing={viewing}
					key={`filters-neighborhoods`}
					onMouseEnter={() => {
						console.log("hovering over neighborhoods in option")
						setFilterNeighborhoodOpen(true)
					}}
					onMouseLeave={() => {
						console.log("leaving neighborhoods in option")
						setFilterNeighborhoodOpen(false)
					}}>
					<OptionScreen
						onClick={() => {
							setFilterNeighborhoodOpen(true)
						}}
					/>
					<label>SECTIONS</label>
					<SelectNeighborhoods>Select Options&nbsp;&gt;</SelectNeighborhoods>
					{filterNeighborhoodOpen && (
						<OptionBox
							color={data.property.color}
							onMouseLeave={(e) => {
								// Check if still hovering over parent Option element
								const option = e.currentTarget.closest(".pipsy__optionNeighborhoods")
								if (!option.matches(":hover")) {
									console.log("leaving neighborhoods in optionbox")
									setFilterNeighborhoodOpen(false)
								}
							}}>
							<OptionClose onClick={() => setFilterNeighborhoodOpen(false)}>
								<FontAwesomeIcon icon={faTimesCircle} color={tertiaryColor()} />
							</OptionClose>
							<OptionList>
								{outputNeighborhoods()}
								<li
									style={{
										paddingTop: 15,
										marginTop: 15,
										borderTop: `1px solid`,
										borderColor: tertiaryColor(),
									}}
									onClick={() => {
										let sel = clone(selections)
										sel.neighborhoods = map(data.neighborhoods, (v) => v.id)
										setSelections(sel)
										try {
											let ev = new Event("pipsy__filter")
											ev.pipsy__type = "neighborhoods__selectAll"
											document.dispatchEvent(ev)
										} catch (e) {}
									}}>
									Select All
								</li>
								<li
									onClick={() => {
										let sel = clone(selections)
										sel.neighborhoods = []
										setSelections(sel)
										fireEvent(
											{
												type: "neighborhoods__deselectAll",
												data: null,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									Deselect All
								</li>
								<SubmitBuilders onClick={() => setFilterNeighborhoodOpen(false)}>SUBMIT</SubmitBuilders>
							</OptionList>
						</OptionBox>
					)}
				</Option>
			)
		}

		const displayLotTypes = () => {
			return (
				<Option
					className="pipsy__optionLotTypes"
					ref={lotTypesDropdown}
					viewing={viewing}
					key={`filters-lotTypes`}
					onMouseEnter={() => setFilterLotTypeOpen(true)}
					onMouseLeave={() => setFilterLotTypeOpen(false)}>
					<OptionScreen
						onClick={() => {
							setFilterLotTypeOpen(true)
						}}
					/>
					<label>LOT TYPES</label>
					<SelectBuilders>Select Options&nbsp;&gt;</SelectBuilders>
					{filterLotTypeOpen && (
						<OptionBox
							color={data.property.color}
							onMouseLeave={(e) => {
								// Check if still hovering over parent Option element
								const option = e.currentTarget.closest(".pipsy__optionLotTypes")
								if (!option.matches(":hover")) {
									setFilterLotTypeOpen(false)
								}
							}}>
							<OptionClose onClick={() => setFilterLotTypeOpen(false)}>
								<FontAwesomeIcon icon={faTimesCircle} color={tertiaryColor()} />
							</OptionClose>
							<OptionList>
								{outputLotTypes()}
								<li
									style={{
										paddingTop: 15,
										marginTop: 15,
										borderTop: `1px solid`,
										borderColor: tertiaryColor(),
									}}
									onClick={() => {
										let sel = clone(selections)
										sel.lot_types = map(data.property?.active_lot_types, (v) => parseInt(v.id))
										setSelections(sel)
										try {
											let ev = new Event("pipsy__filter")
											ev.pipsy__type = "lot_types__selectAll"
											document.dispatchEvent(ev)
										} catch (e) {}
									}}>
									Select All
								</li>
								<li
									onClick={() => {
										let sel = clone(selections)
										sel.lot_types = []
										setSelections(sel)
										fireEvent(
											{
												type: "lot_types__deselectAll",
												data: null,
												name: null,
											},
											lastEvent,
											setLastEvent,
											{ domain, pipsyClient, propertyID }
										)
									}}>
									Deselect All
								</li>
								<SubmitBuilders onClick={() => setFilterLotTypeOpen(false)}>SUBMIT</SubmitBuilders>
							</OptionList>
						</OptionBox>
					)}
				</Option>
			)
		}

		const displayBeds = () => {
			if (get(props, `property.disabled.beds`)) return null
			return (
				<Option className="pipsy__optionBeds" viewing={viewing} key={`filters-beds`}>
					<Label>BEDS</Label>
					<Range
						min={ranges.beds[0]}
						max={ranges.beds[1]}
						marks={marks.beds}
						step={1}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.beds}
						value={selections.beds}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.beds = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new beds...the keys are still the numbers of original low/high
							marksClone.beds[defaultMarks.beds[0]] = numeral(v[0]).format("0,0")
							marksClone.beds[defaultMarks.beds[1]] = numeral(v[1]).format("0,0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "beds",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displayBaths = () => {
			if (get(props, `property.disabled.beds`)) return null
			return (
				<Option className="pipsy__optionBaths" viewing={viewing}>
					<Label>BATHS</Label>
					<Range
						min={ranges.baths[0]}
						max={ranges.baths[1]}
						marks={marks.baths}
						step={1}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.baths}
						value={selections.baths}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.baths = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new baths...the keys are still the numbers of original low/high
							marksClone.baths[defaultMarks.baths[0]] = numeral(v[0]).format("0,0")
							marksClone.baths[defaultMarks.baths[1]] = numeral(v[1]).format("0,0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "baths",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displaySqft = () => {
			if (get(props, `property.disabled.sqft`)) return null
			return (
				<Option className="pipsy__optionSqft" viewing={viewing}>
					<Label>SQUARE FOOTAGE</Label>
					<Range
						min={ranges.sqft[0]}
						max={ranges.sqft[1]}
						marks={marks.sqft}
						step={100}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.sqft}
						value={selections.sqft}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.sqft = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new sqft...the keys are still the numbers of original low/high
							marksClone.sqft[defaultMarks.sqft[0]] = numeral(v[0]).format("0,0")
							marksClone.sqft[defaultMarks.sqft[1]] = numeral(v[1]).format("0,0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "sqft",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displayPrice = () => {
			if (get(props, `property.disabled.price`)) return null
			return (
				<Option className="pipsy__optionPrice" viewing={viewing}>
					<Label>PRICE RANGE</Label>
					<Range
						min={ranges.price[0]}
						max={ranges.price[1]}
						marks={marks.price}
						step={10000}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.price}
						value={selections.price}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.price = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new price...the keys are still the numbers of original low/high
							marksClone.price[defaultMarks.price[0]] = numeral(v[0]).format("0,0")
							marksClone.price[defaultMarks.price[1]] = numeral(v[1]).format("0,0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "price",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displayAcreage = () => {
			// This is sort of useless?

			if (get(props, `property.disabled.acreage`)) return null
			return (
				<Option className="pipsy__optionAcreage" viewing={viewing}>
					<Label>ACREAGE</Label>
					<Range
						min={ranges.acreage[0]}
						max={ranges.acreage[1]}
						marks={marks.acreage}
						step={100}
						allowCross={false}
						trackStyle={[
							{
								backgroundColor: tertiaryColor(),
							},
						]}
						handleStyle={[
							{
								borderColor: "#444",
								...handleSize,
							},
							{
								borderColor: tertiaryColor(),
								...handleSize,
							},
						]}
						defaultValue={selections.acreage}
						value={selections.acreage}
						onChange={(v) => {
							let selects = cloneDeep(selections)
							selects.acreage = v
							let marksClone = cloneDeep(marks)
							// Update the low and high marks to reflect the new acreage...the keys are still the numbers of original low/high
							marksClone.acreage[defaultMarks.acreage[0]] = numeral(v[0]).format("0,0")
							marksClone.acreage[defaultMarks.acreage[1]] = numeral(v[1]).format("0,0")
							setSelections(selects)
							setMarks(marksClone)
						}}
						onAfterChange={(v) => {
							fireEvent(
								{
									type: "acreage",
									data: v,
									name: null,
								},
								lastEvent,
								setLastEvent,
								{ domain, pipsyClient, propertyID }
							)
						}}
					/>
				</Option>
			)
		}

		const displayFavorites = () => {
			if (get(props, `property.disabled.favorites`)) return null
			return (
				<FavoriteBox
					favorite={true}
					key={"favoriteBox"}
					viewing={viewing}
					className="pipsy__optionFavorites"
					onClick={() => {
						setViewingFavorites(!viewingFavorites)
						fireEvent(
							{
								type: "favorites",
								data: viewingFavorites ? false : true,
								name: null,
							},
							lastEvent,
							setLastEvent,
							{ domain, pipsyClient, propertyID }
						)
					}}>
					<Label>
						FAVORITES{" "}
						{favorites && favorites.length > 0 && <FavoriteCount>({favorites.length})</FavoriteCount>}
					</Label>
					{viewingFavorites && <FontAwesomeIcon icon={faHeartFilled} color={"#E53603"} />}
					{!viewingFavorites && <FontAwesomeIcon icon={faHeart} color={"#E53603"} />}
				</FavoriteBox>
			)
		}

		const tertiaryColor = () => {
			// Check if this property wants secondary colors, if so returns that color, if not then returns the default theme color
			if (get(props, `property.enabled.tertiaryColor`)) return props.property.accent_color
			return props.property.color
		}

		const changeFeatures = (v) => {
			try {
				let clone = cloneDeep(selectedAreaFeatures)
				if (clone.includes(v)) clone = remove(clone, (r) => r !== v)
				else clone.push(v)
				clone.sort()
				setSelectedAreaFeatures(clone)
			} catch (e) {}
		}

		const featuresCategories = () => {
			try {
				let cats = []
				forEach(props.area_features, (v) => {
					if (viewing == "amenities" && v.amenity) cats.push(v.category)
					else if (viewing == "area_features" && !v.amenity) cats.push(v.category)
				})
				cats = uniq(cats)
				cats.sort()
				let ret = []
				forEach(cats, (v) => {
					ret.push(
						<FeaturesItem
							className="pipsy__featureButton"
							onClick={() => changeFeatures(v)}
							selects={selectedAreaFeatures}
							category={v}
							key={v}>
							<span>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
									<path
										d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
										fill={`#fff`}
									/>
								</svg>
								{v}
							</span>
						</FeaturesItem>
					)
				})
				return ret
			} catch (e) {
				return ""
			}
		}

		const decideFilters = () => {
			if (viewing === "lot_finder") {
				let filters = document.getElementById("pipsy__inventory").getAttribute("data-filters")
				// Check for the tools they want on the root tag
				let ret = []
				if (filters) {
					filters = filters.split(",")
					if (filters.includes("builders")) {
						ret.push(displayBuilders())
					}
					if (filters.includes("lot_types")) {
						ret.push(displayLotTypes())
					}
					if (filters.includes("neighborhoods")) {
						ret.push(displayNeighborhoods())
					}
					ret.push(displayFavorites())
					return <>{ret}</>
				} else {
					ret = [displayBuilders(), displayLotTypes(), displayFavorites()]
					if (get(props, `property.enabled.sites`)) ret.splice(ret.length - 1, 0, displaySites())
					return ret
				}
			}
			let neighborhoods = null
			if (props?.property?.enabled?.neighborhoods) neighborhoods = displayNeighborhoods()
			// Normal filters
			return (
				<>
					{displayBuilders()}
					{displayPrice()}
					{displaySqft()}
					{displayBeds()}
					{displayBaths()}
					{displayStories()}
					{displaySites()}
					{neighborhoods}
					{displayFavorites()}
				</>
			)
		}

		const handleSize = largeDevice ? { width: 14, height: 14 } : { width: 20, height: 20, marginTop: -9 }
		if (ready) {
			return (
				<ThemeProvider theme={theme}>
					<Global className="pipsy__globalContainer">
						{mode !== "tv" ? (
							<MobileFilterTrigger
								mobileFiltersOpen={mobileFiltersOpen}
								mode={mode || null}
								className="pipsy__mobileFilterTrigger">
								<ToggleFavorites onClick={() => setViewingFavorites(!viewingFavorites)}>
									{viewingFavorites && <FontAwesomeIcon icon={faHeartFilled} color={"#fff"} />}
									{!viewingFavorites && <FontAwesomeIcon icon={faHeart} color={"#fff"} />}
								</ToggleFavorites>
								<SearchFiltersButton onClick={() => setMobileFiltersOpen(true)}>
									SEARCH FILTERS &gt;
								</SearchFiltersButton>
								{showMap && (
									<MapIcon onClick={() => scrollToMap()}>
										<FontAwesomeIcon icon={faMapMarkedAlt} color={"#fff"} />
									</MapIcon>
								)}
								{!showMap && <NoMap></NoMap>}
							</MobileFilterTrigger>
						) : null}
						{get(props, `property.disabled.filters`) ? (
							""
						) : (
							<div className="lg:min-h-[75px] pipsy__toolsGlobal">
								<ToolsContainer
									className="pipsy__toolsContainer"
									mode={mode || null}
									mobileFiltersOpen={mobileFiltersOpen}
									{...{ viewing }}>
									<MobileCloseContainer
										className="pipsy__optionMobileClose"
										onClick={() => setMobileFiltersOpen(false)}>
										<FontAwesomeIcon icon={faTimesCircle} color={tertiaryColor()} />
									</MobileCloseContainer>
									{decideFilters()}
									{["builderDetail"].includes(mode) ? null : (
										<Reset className="pipsy__optionReset" onClick={() => reset()} viewing={viewing}>
											<FontAwesomeIcon icon={faUndo} color={"#222"} />
										</Reset>
									)}
									<MobileSubmit
										className="pipsy__optionMobileSubmit"
										onClick={() => setMobileFiltersOpen(false)}>
										SEARCH
									</MobileSubmit>
								</ToolsContainer>
								<FeaturesTools className="pipsy__featuresTools" viewing={viewing} mode={mode || null}>
									<FeaturesTitle className="pipsy__featuresTitle">
										<span>CATEGORIES</span>
										<FeaturesSelectAllContainer>
											<FeaturesSelectAllBox
												onClick={() => {
													let cats = map(props.area_features, (v) => v.category)
													cats = uniq(cats)
													cats.sort()
													setSelectedAreaFeatures(cats)
												}}>
												SELECT ALL
											</FeaturesSelectAllBox>
											<FeaturesSelectAllBox
												onClick={() => {
													setSelectedAreaFeatures([])
												}}>
												DESELECT ALL
											</FeaturesSelectAllBox>
										</FeaturesSelectAllContainer>
									</FeaturesTitle>
									<FeaturesList>{featuresCategories()}</FeaturesList>
								</FeaturesTools>
							</div>
						)}
						<View className="pipsy__globalView">
							{loaded ? (
								<>
									{viewingFavorites && isMobile && (
										<ViewingFaves onClick={() => setViewingFavorites(!viewingFavorites)}>
											Viewing Favorites
										</ViewingFaves>
									)}
									<List className="pipsy__listCont">
										<PublicList
											data={data}
											selections={selections}
											options={options}
											theme={theme}
											storeFavorite={storeFavorite}
											removeFavorite={removeFavorite}
											buildMatchLists={buildMatchLists}
										/>
									</List>
									{showMap && !isMobile && (
										<LazyLoad height={isMobile ? "93vh" : "auto"}>
											<Map id="pipsy__map">
												<Suspense fallback="">
													<PublicMap
														key="desktopMap"
														data={data}
														theme={theme}
														isMobile={false}
													/>
												</Suspense>
											</Map>
										</LazyLoad>
									)}
									{mobileContactOpen && (
										<Suspense fallback={<div></div>}>
											<MobileForm theme={theme} />
										</Suspense>
									)}
								</>
							) : (
								<></>
							)}
						</View>
					</Global>
				</ThemeProvider>
			)
		}
		return ""
	}

	if (ready) return <InventoryGlobal props={data} />
	else return ""
}

export default PipsyWrapper
